var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-calibration-sequence"},[_c('IconMaterial',{attrs:{"title":"group_work","size":_vm.size}}),_c('span',{staticClass:"icon-calibration-sequence__letter"},[_vm._v("с")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }